/**
 * Getters for wordpress/settings module
 */
const getters = {
  all: state => state,
  json: state => JSON.stringify(state, null, 4),
  logo: state => state.site.logo,
  owner: state => state.site.owner,
  contact: state => state.contact,
  fullAddress: state => (!state.address.postalCode || !state.address.addressRegion || !state.address.addressLocality || !state.address.streetAddress) ? '' : `〒${state.address.postalCode} ${state.address.addressRegion}${state.address.addressLocality}${state.address.streetAddress}`
}

export default getters



// WEBPACK FOOTER //
// ./src/store/modules/wordpress/settings/getters.js